import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=65fbcdf3&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=65fbcdf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbcdf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fbcdf3')) {
      api.createRecord('65fbcdf3', component.options)
    } else {
      api.reload('65fbcdf3', component.options)
    }
    module.hot.accept("./OrderList.vue?vue&type=template&id=65fbcdf3&scoped=true&", function () {
      api.rerender('65fbcdf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/OrderList.vue"
export default component.exports